import NBType, { InferType } from '@netbase/nb-type'
import LogoPrecision from '../enums/LogoPrecision'

const CVLogoSchema = NBType.object().shape('CVLogoSchema', {
  /* @prop */
  logoPrecisions: NBType.array().of(NBType.enum(LogoPrecision)),
  /* @prop */
  logoTypes: NBType.array().of(NBType.string())
  /* END */
})
export default CVLogoSchema
export type CVLogo = InferType<typeof CVLogoSchema>
// RESERVE BELOW
